import { InstanceTypeOf } from '@/type-utils';
import { errorFactory } from '@/utils/error-utils';
import { SwatchValidationError } from './SwatchValidationError';

export const { EmptyHexArrayError } = errorFactory(
  'EmptyHexArrayError',
  SwatchValidationError
);

/**
 * Error thrown when a swatch has an empty array for its hexValue.
 *
 * Gradient swatches require at least one color value.
 */
export type EmptyHexArrayError = InstanceTypeOf<typeof EmptyHexArrayError>;
